var list = [
  "/enterprise/service-org-info/countAll",
  "/enterprise/base-info/countAll",
  "/enterprise/base-info/get-com-base-info-by-id",
  "/approve/apply-public/page-apply-public-list",
  "/policy/page-policy-info-list",
  "/enterprise/service-org-info/get-third-service-org-info-no-auth",
  "/enterprise/service-org-info/page-com-service-org-info-list",
  "/policy/category/page-policy-category-list",
  "/enterprise/service-org-info/get-hot-service-org-list",
  "/notice/list",
  "/enterprise/appraise/list"
];
var newList = [];
list.forEach(item => {
  item = process.env.NODE_ENV_TOW + item;
  newList.push(item);
});
export default newList;



// WEBPACK FOOTER //
// ./src/utils/whiteList.js